class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    
    // Single Select collection start
    let searchKeys;
    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      let newUrl = new URL(window.location.origin + url);
      const params = new URLSearchParams(newUrl.search);

      if (event) {
        let targetElement = event.target;
        if(targetElement.type === 'checkbox' && targetElement.getAttribute('name').includes('collections')){
          let checkboxes = targetElement.closest('ul').querySelectorAll('input[name="filter.p.m.custom.collections-rcpo"]');
          checkboxes.forEach(checkbox=>{
            if (checkbox != targetElement) {
              checkbox.checked = false;
            }
          });
          
          let targetValue = targetElement.checked ? targetElement.value : "";
          params.set(targetElement.getAttribute('name'), targetValue);
          newUrl.search = params.toString();
          url = newUrl.href.replace(window.location.origin, "");
          searchKeys = newUrl.search.replace(`?section_id=${section.section}&`, "");
        }
      }
      
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchKeys || searchParams);
    // window.location.reload();
  }

  static renderSectionFromFetch(url, event) {
    let mobileFilters = document.querySelectorAll('.mobile-facets details.mobile-facets__details .mobile-facets__submenu .option-top-section-with-reset-section');
    let desktopSummary = document.querySelectorAll(".facets__form summary");
    let activeIndexes = [];
    let desktopActiveIndexes = [];
    mobileFilters.forEach((item, index)=>{
      if (item.classList.contains('active')) {
        activeIndexes.push(index);
      }
    })
    desktopSummary.forEach((item, index)=>{
      if (item.classList.contains('active')) {
        desktopActiveIndexes.push(index);
      }
    })
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (loaderImg) {
          loaderImg.style.display = 'flex';
        }
        setTimeout  (() => {
          if (loaderImg) {
            loaderImg.style.display = 'none';
          }
          adjustWidth()
          mobileFilterAccordion(activeIndexes);
          desktopFilterAccordian(desktopActiveIndexes);
          if(window.showProducts){
            window.showProducts();
          }
          visiblereset()
          checkRange()
          updatedPriceDesktop()
          updatedPriceMobile()
          collectionChecked()
          buttomReset()
          collectionResetButton()
          showMoreProductCheck()
        }, 1000)
      });
    let mobileFacets = document.querySelector('.mobile-facets__main');
     setTimeout( ()=>{
        mobileFacets.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }, 2000)
  }
  

  static renderSectionFromCache(filterDataUrl, event) {
    let mobileFilters = document.querySelectorAll('.mobile-facets details.mobile-facets__details .mobile-facets__submenu .option-top-section-with-reset-section');
    let desktopSummary = document.querySelectorAll(".facets__form summary");
    let activeIndexes = [];
    let desktopActiveIndexes = [];
    mobileFilters.forEach((item, index)=>{
      if (item.classList.contains('active')) {
        activeIndexes.push(index);
      }
    })
    desktopSummary.forEach((item, index)=>{
      if (item.classList.contains('active')) {
        desktopActiveIndexes.push(index);
      }
    })
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (loaderImg) {
        loaderImg.style.display = 'flex';
    }
        setTimeout  (() => {
          if (loaderImg) {
            loaderImg.style.display = 'none';
          }
          adjustWidth()
          mobileFilterAccordion(activeIndexes);
          desktopFilterAccordian(desktopActiveIndexes);
          if(window.showProducts){
            window.showProducts();
          }
            visiblereset()
            checkRange()
          checker()
            updatedPriceDesktop();
          updatedPriceMobile();
          collectionChecked()
           buttomReset()
          collectionResetButton()
          showMoreProductCheck()
        }, 1000)
      let mobileFacets = document.querySelector('.mobile-facets__main');
     setTimeout( ()=>{
        mobileFacets.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }, 2000)
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
            if(window.showProducts){
              window.showProducts();
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
          if(window.showProducts){
            window.showProducts();
          }
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  async closeFilter(event) {
    event.preventDefault();
    const form = await this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    await form.onActiveFilterClick(event);
    setTimeout(() => {
       checker()
    }, 2000);
  }
}


function checker(){
  // desktop
  var parentDiv = document.querySelector('.active-facets.active-facets-desktop');
var facetRemoveElements
if (parentDiv) {
  facetRemoveElements = parentDiv.querySelectorAll('facet-remove');
  recheck(facetRemoveElements, parentDiv)

}


function recheck(facetRemoveElements, parentDiv){
if (facetRemoveElements.length < 2) {
  var newDiv = document.createElement('div');

  newDiv.className = 'no-filter-apply';

  newDiv.textContent = '0 filters applied';

  parentDiv.appendChild(newDiv);
}
}


  // mobile
    var parentDivMobile = document.querySelector('.active-facets.active-facets-mobile');

    if (parentDivMobile) {
    var facetRemoveElements = parentDivMobile.querySelectorAll('facet-remove');
        recheck(facetRemoveElements, parentDivMobile)
  }
      function recheck(facetRemoveElements, parentDivMobile){
    if (facetRemoveElements.length < 2) {
        var newDiv = document.createElement('div');

        newDiv.className = 'no-filter-apply';

        newDiv.textContent = '0 filters applied';

        parentDivMobile.appendChild(newDiv);
    }
    }

}

// reset visible JS
document.addEventListener('DOMContentLoaded', () => {
  visiblereset()
  updatedPriceDesktop();
  updatedPriceMobile();
});

function visiblereset() {
  document.querySelectorAll('.individual-reset-buttom').forEach(ele => {
      
      let inputs = ele.parentElement.nextElementSibling.querySelectorAll('li input[type="checkbox"]')
   
    let arrayCheck = Array.from(inputs).filter(a=>a.checked)
      if(arrayCheck.length){
          ele.style.visibility='visible';
      } else {
         ele.style.visibility='hidden';
      }
  })
}

// JS for "+" PriceRange on filter options to the Desktop
  function updatedPriceDesktop() {
    var priceElements = document.querySelectorAll('.list-menu__item label input[type="checkbox"]');

    priceElements.forEach(function (priceElement) {
      
      var originalValue = priceElement.value.trim();

      if (originalValue.includes("+")) {
        var modifiedValue = originalValue.replace("-", "").trim();

        var spanElement = priceElement.parentElement.querySelector('span[aria-hidden="true"]');
          spanElement.textContent = modifiedValue;
          spanElement.classList.add("modified-value");
      }
    });
  }

// JS for "+" PriceRange on filter options to the Mobile
  function updatedPriceMobile() {
    var priceElementsMobiles = document.querySelectorAll('.mobile-facets__item label input[type="checkbox"]');
    priceElementsMobiles.forEach(function (priceElementsMobile) {
      
      var originalValue = priceElementsMobile.value.trim();

      if (originalValue.includes("+")) {
        var modifiedValue = originalValue.replace("-", "").trim();
      
        var spanElement = priceElementsMobile.parentElement.querySelector('span[aria-hidden="true"]');
          spanElement.textContent = modifiedValue;
          spanElement.classList.add("modified-value");
      }
    });
  }

//show more btn hiding after filteration
function showMoreProductCheck() {
    let nextPage = $('.paginate .next');
    const button = $('.showMoreButton a.more-results');
    if(!nextPage.length){
      button.hide();
    }
  }

  function collectionResetButton() {
    let collectionReset = document.querySelector('.mobile-custom-collection-filter .option-top-section-with-reset-section .individual-reset-buttom');
    collectionReset.style.setProperty('visibility', 'visible', 'important');
    collectionReset.addEventListener('click', (e) => {
        window.location.href = '/collections/rolex-certified-pre-owned-watches';
    });
  }

customElements.define('facet-remove', FacetRemove);



window.onload=()=>{
  adjustWidth();
  let mobileFiltersRemove = $('.mobile-facets details.mobile-facets__details .mobile-facets__submenu .option-top-section-with-reset-section');
  mobileFiltersRemove.removeClass('active');
  mobileFiltersRemove.next().removeClass('active');
  mobileFilterAccordion([]);
  if(window.location.pathname == '/collections/rolex-certified-pre-owned-watches') {
    desktopFilterAccordian([]);
  }
}
// Select all <select> elements to adjust width dynamically
function adjustWidth() {
  
  const selectElements = document.querySelectorAll('select');

  selectElements.forEach((select) => {
    // Create a temporary div for measurement
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.whiteSpace = 'nowrap';
    tempDiv.style.font = window.getComputedStyle(select).font;

    // Set the text of the temporary div to the selected option's text
    tempDiv.textContent = select.options[select.selectedIndex].text;
    document.body.appendChild(tempDiv);

    // Adjust the select width to match the text width
    select.style.width = `${tempDiv.offsetWidth + 32}px`;

    // Clean up the temporary div
    document.body.removeChild(tempDiv);
  });
}

function mobileFilterAccordion(activeContent) {
   const mobileFilters = $('.mobile-facets details.mobile-facets__details .mobile-facets__submenu .option-top-section-with-reset-section');
    activeContent.forEach((el) => {
      mobileFilters[el].classList.add('active');
      mobileFilters[el].nextElementSibling.classList.add('active');
    })
  mobileFilters.off('click');
  mobileFilters.on('click', function(event){
    const target = event.target;
    $(target).toggleClass('active');
    $(target).next().toggleClass('active');
  });
}

function desktopFilterAccordian(activeContent) {
  let desktopSummary = document.querySelectorAll(".facets__form summary");
    activeContent.forEach((el) => {
      desktopSummary[el].classList.add('active');
    })
    // Attach click event handler
    desktopSummary.forEach(function (summary) {
        summary.addEventListener("click", function () {
          summary.classList.toggle("active");
        });
    });
}